import {useContext, useEffect} from "react";

import {NotificationsContext} from "@ui-components/Notifications";
import {DataContext} from "../DataContext/DataContext";
import apiRequest from "../apiRequest";

const useCities = () => {
  const {push} = useContext(NotificationsContext);
  const dataContext = useContext(DataContext);

  useEffect(() => {
    let closed = false;
    const fetchData = async () => {
      try {
        const data = await apiRequest.get(`/cities`);
        if (!closed) {
          dataContext.setCities(data);
        }
      } catch (error) {
        console.log(error)
        dataContext.setCities(false);
        if (!closed) {
          push({
            title: "Errore durante il caricamento",
            type: "error",
          });
        }
      }
    };

    if (dataContext.cities === null) {
      fetchData();
    }

    return () => {
      closed = true;
    };
  }, [dataContext.cities, push]);  // eslint-disable-line react-hooks/exhaustive-deps

  if (!dataContext.cities) {
    return undefined
  }

  return dataContext.cities;

};

export default useCities;
